'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AccordionItemTitle = require('./AccordionItemTitle.scss');

var _AccordionItemTitle2 = _interopRequireDefault(_AccordionItemTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionItemTitle = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AccordionItemTitle, _Component);

  function AccordionItemTitle() {
    (0, _classCallCheck3.default)(this, AccordionItemTitle);
    return (0, _possibleConstructorReturn3.default)(this, (AccordionItemTitle.__proto__ || (0, _getPrototypeOf2.default)(AccordionItemTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(AccordionItemTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          title = _props.title,
          uuid = _props.uuid,
          onClick = _props.onClick;

      var ariaControls = 'enterprise-accordion-item-body-' + uuid;
      var id = 'enterprise-accordion-item-title-' + uuid;
      var _className = (0, _classnames2.default)(className, _AccordionItemTitle2.default.root);

      if ((typeof title === 'undefined' ? 'undefined' : (0, _typeof3.default)(title)) === 'object') {
        return _react2.default.cloneElement(title, {
          'aria-controls': ariaControls,
          id: id,
          onClick: onClick
        });
      }

      return _react2.default.createElement(
        'div',
        {
          'aria-controls': ariaControls,
          id: id,
          className: _className,
          onClick: onClick,
          style: style
        },
        title
      );
    }
  }]);
  return AccordionItemTitle;
}(_react.Component), _class.propTypes = {
  /* Text to display in header */
  title: _react.PropTypes.node.isRequired,
  /* Unique identifier of the item */
  uuid: _react.PropTypes.string,

  /* Callback for when item title is clicked */
  onClick: _react.PropTypes.func,

  /* Custom className applied to root item div */
  className: _react.PropTypes.string,
  /* Inline styles applied to root div */
  style: _react.PropTypes.object
}, _temp);
exports.default = AccordionItemTitle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseAccordion/AccordionItemTitle/AccordionItemTitle.jsx
// module id = 656
// module chunks = 0